
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment-timezone';
import { namespace } from "vuex-class";

import "@/store/modules/common";
const commonState = namespace("Common");

import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form4";
const form4State = namespace("Form4");

import AddAffidavitForm from './AddAffidavitForm.vue';

import { affidavitInfoType, form4DataInfoType, orderInfoType } from '@/types/Information/Form4';
import { partiesDataJsonDataType } from '@/types/Information/json';
import { hearingLocationsInfoType, locationsInfoType } from '@/types/Common';

@Component({
    components:{        
        AddAffidavitForm        
    }
})
export default class Form4StyleOfProceeding extends Vue {

    @commonState.State
    public locationsInfo!: locationsInfoType[]; 
    
    @commonState.State
    public hearingLocationsInfo!: hearingLocationsInfoType[];
    
    @informationState.State
    public partiesJson: partiesDataJsonDataType;

    @informationState.State
    public fileNumber: string;

    @form4State.State
    public form4Info: form4DataInfoType;

    @form4State.Action
    public UpdateForm4Info!: (newForm4Info: form4DataInfoType) => void  
    
    @form4State.State
    public currentNoticeOfApplicationId: string;

    @form4State.Action
    public UpdateCurrentNoticeOfApplicationId!: (newCurrentNoticeOfApplicationId: string) => void
    
    dataReady = false;
    applicantNames: string[] = [];
    respondentNames: string[] = [];
    partyNames: string[] = [];
    otherPartyNames: string[] = [];
    hearingLocationList: string[] = [];
    otherHearingLocationList: string[] = [];
    hearingLocation = "";
    otherHearingLocation = "";

    updated=0; 
    addAffidavitFormColor = 'court';
    AddNewAffidavitForm = false;
    latestEditAffidavitData;
    isEditAffidavitOpen = false;

    affidavitFields = [
        {
            key:'name',          
            label:'Name',                  
            thClass: 'text-white bg-court',
            thStyle: 'font-size: 1rem;',            
            sortable:false            
        }, 
        {
            key:'date',          
            label:'Date',   
            thClass: 'text-white bg-court', 
            thStyle: 'font-size: 1rem;',          
            sortable:false            
        }, 
        {
            key:'edit',          
            label:'',   
            thClass: 'text-white bg-court',           
            sortable:false            
        }        
    ]
    
    yesNoOptions = [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
    ];

    contestedOptions = [
        {text: 'Contested', value: true},
        {text: 'Uncontested', value: false}
    ];

    orderList = []

    orderListJudge = [
        'adjournment',
        'to consolidate or have appeals heard together',
        'directions',
        'dismissal of appeal in chambers',
        'dismissal (other)',
        'extend time to file books or documents',
        'extend time to appeal or cross-appeal',
        'intervener status',
        'leave to appeal',
        'payment of security',
        'reinstate appeal that is dismissed as abandoned',
        'remove appeal from the inactive list',          
        'stay of proceedings or execution',    
        'varying or cancelling an order of the registrar',
        'other'
    ];

    orderListRegistrar = [        
        'assessment',
        'settle order',
        'settle order and assessment',
        'settle contents of books',    
        'extend time to file books or documents',
        'extend time to appeal or cross-appeal',   
        'other'
    ];

    orderListCourt = [
        'adjournment',
        'adducing fresh or new evidence',
        'to consolidate or have appeals heard together',
        'directions',        
        'dismissal (other)',        
        'quashing an appeal or raising a preliminary objection',        
        'other'
    ];

    jurisdictionTypeOptions = [ 'The Court (3 Judges)', 'A Chambers Judge', 'The Registrar' ];

    state = {
        applicantParties:null,            
        respondentParties: null,  
        jurisdictionType: null,  
        hearingLocation: null,
        hearingLocationOther: null, 
        hearingDate: null, 
        estimatedDuration: null,
        relyingSectionRule: null, 
        orderList: null,
        seekingOrder: null, 
        bookRequired: null, 
        affidavitList: null, 
        applicationContested: null, 
        acknowledgeEmailService: null, 
        emailAddresses: null,     
        selfRepresented: null,         
        authorizedName:null
    }

    invalidApplicantParties = false;

    mounted() {
        this.dataReady = false;
        this.extractInfo();
        this.changeOrderList(true)             
    }

    public extractInfo(){

        this.hearingLocationList = [];
        
        for (const hearingLocation of this.hearingLocationsInfo){
            if (hearingLocation.other){
                this.otherHearingLocationList.push(hearingLocation.name);
            } else {
                this.hearingLocationList.push(hearingLocation.name);    
            }           
        }

        this.hearingLocationList.push('Other');

        this.invalidApplicantParties = false;

        if(this.currentNoticeOfApplicationId){
            this.getForm4Data();
           
        } else {   
            
            const form4Data = {} as form4DataInfoType;

            let applicantNames = [];
            let respondentNames = [];

            form4Data.appellants = this.partiesJson.appellants
            form4Data.respondents = this.partiesJson.respondents;

            for (const respondent of form4Data.respondents){
                respondentNames.push(respondent.name);                
            }

            for (const applicant of form4Data.appellants){
                applicantNames.push(applicant.name);                
            }

            form4Data.appellantNames = applicantNames.join(', ');
            form4Data.respondentNames = respondentNames.join(', ');

            form4Data.formSevenNumber = this.fileNumber;
            
            form4Data.version = this.$store.state.Application.version;  
            form4Data.selfRepresented = this.$store.state.Common.userSelfRepresented;
            form4Data.affidavitList = [];   
            form4Data.orderList = []; 
            form4Data.seekingOrder = [];         
           
            this.UpdateForm4Info(form4Data);                       
            this.saveForm(true);
        }

    }

    public extractPartiesData(){

        this.applicantNames = [];
        this.respondentNames = [];
        this.partyNames = [];

        for (const respondent of this.form4Info.respondents){
            this.respondentNames.push(respondent.name); 
            this.partyNames.push(respondent.name) 
        }

        for (const applicant of this.form4Info.appellants){
            this.applicantNames.push(applicant.name);
            this.partyNames.push(applicant.name);  
        }
        this.updateOtherParties();
        this.dataReady = true;
    }

    public update(){ 
              
        const form4 = this.form4Info;
       
        form4.hearingLocation = {} as hearingLocationsInfoType;
       
        if (this.hearingLocation == 'Other' && this.otherHearingLocation.length > 0){
            form4.hearingLocation = this.hearingLocationsInfo.filter(location => location.name == this.otherHearingLocation)[0]
        } else if (this.hearingLocation != 'Other') {
            form4.hearingLocation = this.hearingLocationsInfo.filter(location => location.name == this.hearingLocation)[0]
        }  
        
        this.UpdateForm4Info(form4);
        this.recheckStates();
    }

    public getForm4Data() {        
       
        this.$http.get('/form4/forms/'+this.currentNoticeOfApplicationId)
        .then((response) => {
            if(response?.data?.data){            
                            
                const form4Data = response.data.data                
                this.UpdateForm4Info(form4Data);
                if (form4Data.hearingLocation?.name){

                    if (this.hearingLocationList.includes(form4Data.hearingLocation.name)){
                        this.hearingLocation = form4Data.hearingLocation.name;
                        this.otherHearingLocation = '';            
                    } else {
                        this.hearingLocation = 'Other';
                        this.otherHearingLocation = form4Data.hearingLocation.name;            
                    }
                    
                } else {
                    this.hearingLocation = '';
                    this.otherHearingLocation = '';
                } 

                this.extractPartiesData();
                this.clearStates();                
            }
                
        },(err) => {
            console.log(err)        
        });      
    }

     public clearStates(){
        this.state = {            
            applicantParties:null,            
            respondentParties: null,  
            jurisdictionType: null,  
            hearingLocation: null,
            hearingLocationOther: null, 
            hearingDate: null, 
            estimatedDuration: null,
            relyingSectionRule: null, 
            orderList: null,
            seekingOrder: null, 
            bookRequired: null, 
            affidavitList: null, 
            applicationContested: null, 
            acknowledgeEmailService: null, 
            emailAddresses: null,     
            selfRepresented: null,         
            authorizedName:null
        }
        this.dataReady = true; 
    }

    public recheckStates(){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates()
                return 
            }
        }
    }

    public checkStates(){   
        
        
        this.state.applicantParties = this.form4Info.applicantParties?.length>0? null :false;
        this.state.respondentParties = this.form4Info.respondentParties?.length>0? null :false;
        this.state.jurisdictionType = !this.form4Info.jurisdictionType? false : null;

        this.state.hearingLocation = !this.form4Info.hearingLocation? false : null;
        this.state.hearingLocationOther = this.hearingLocation=='Other' && !this.otherHearingLocation ?false : null;
        this.state.hearingDate = this.form4Info.hearingDate && this.allowedDates(this.form4Info.hearingDate)? null: false; 
        this.state.estimatedDuration = !this.form4Info.estimatedDuration? false : null;         
        this.state.relyingSectionRule = !this.form4Info.relyingSectionRule? false :null;  
          
        this.state.orderList = this.form4Info.orderList?.length>0 ? null: false  
        this.state.seekingOrder = !(this.form4Info.seekingOrder && this.verifyOrders()
                                    && this.form4Info.seekingOrder.length == this.form4Info.orderList?.length)? false : null;       
      
        this.state.bookRequired = this.form4Info.bookRequired==null? false :null
        const affidavitRequired = this.form4Info.bookRequired ==false; 
        this.state.affidavitList = (affidavitRequired && this.form4Info.affidavitList?.length == 0)? false :null 
        this.state.applicationContested = this.form4Info.applicationContested==null? false :null 
        this.state.acknowledgeEmailService = this.form4Info.acknowledgeEmailService==null? false :null
        const emailRequired = this.form4Info.acknowledgeEmailService
        this.state.emailAddresses= (emailRequired && !this.form4Info.emailAddresses)? false :null    
        this.state.selfRepresented = this.form4Info.selfRepresented==null? false :null
        
        this.state.authorizedName = !this.form4Info.authorizedName? false : null;       
        
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }
        }
        return true            
    }   
    
    public verifyOrders(){
        for(const order of this.form4Info.seekingOrder){            
            if(order.details?.trim()?.length == 0)
                return false;
        }
        return true;
    }

    public extractOrderDetails(){
        const orders = [];
        for(const order of this.form4Info.seekingOrder){            
            if(order.details?.trim()?.length != 0){
                orders.push(order.name + ': ' + order.details.trim());
            }  
        }
        return orders.join('<br>');        
    }

    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form4/forms';

        if (this.currentNoticeOfApplicationId){
            method = 'put';
            url = '/form4/forms/'+this.currentNoticeOfApplicationId;               

            if (!draft && !this.checkStates()){               
                return                
            } 

            const form4Data = this.form4Info;
            form4Data.orderDetails = this.extractOrderDetails();
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form4Info,
                    type:'Form4',
                    description:'Notice of Application'
                }
            }
            this.saveInfo(options, draft);

        } else {           

            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form4Info,
                    type:'Form4',
                    description:'Notice of Application'
                }
            }
            this.saveInfo(options, draft);
        }        
       
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentNoticeOfApplicationId(response.data.file_id);
                        this.extractPartiesData();                        
                    }
                    const data = this.form4Info;
                    this.UpdateForm4Info(data)
                    this.clearStates();                    
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;
                
            })
    }
    
    public updateOtherParties(){

        const otherParties = [];

        if (this.partyNames.length == this.form4Info.applicantParties?.length){

            this.invalidApplicantParties = true;

        } else {

            this.invalidApplicantParties = false;

            for (const partyName of this.partyNames){
                const index = this.form4Info.applicantParties?.indexOf(partyName)
                if (index == -1){
                    otherParties.push(partyName);
                }
            }
            this.otherPartyNames = otherParties;
            this.updated ++;
        } 
        this.recheckStates();
    }

    public addNewAffidavit(){
        this.state.affidavitList= null
        if(this.isEditAffidavitOpen){            
            this.addAffidavitFormColor = 'danger'
        }else{
            this.AddNewAffidavitForm = true;            
        }
    }

    public editAffidavit(data) {
        if(this.AddNewAffidavitForm || this.isEditAffidavitOpen){            
            this.addAffidavitFormColor = 'danger';                     
        }else if(!this.isEditAffidavitOpen && !data.detailsShowing){
            data.toggleDetails();
            this.isEditAffidavitOpen = true;
            this.latestEditAffidavitData = data            
        }   
    }

    public modifyAffidavitList(isCreateAffidavit: boolean, newAffidavit: affidavitInfoType, index: number){        

        if (isCreateAffidavit){
            
            const form4Data = this.form4Info;
            form4Data.affidavitList.push(newAffidavit)
            
            this.UpdateForm4Info(form4Data)

            this.closeAffidavitForm();

        } else { 
            
            const form4Data = this.form4Info;
            form4Data.affidavitList[index].date = newAffidavit.date;
            form4Data.affidavitList[index].name = newAffidavit.name;
           
            this.UpdateForm4Info(form4Data);
                      
            this.closeAffidavitForm();
        }
        this.updated ++;
    }

    public removeAffidavit(data){ 
        const form4Data = this.form4Info;       
        form4Data.affidavitList.splice(data.index,1);
        
        this.UpdateForm4Info(form4Data);
        this.updated ++;        
    }

    public closeAffidavitForm() {                     
        this.AddNewAffidavitForm= false; 
        this.addAffidavitFormColor = 'court'
        if(this.isEditAffidavitOpen){
            this.latestEditAffidavitData.toggleDetails();
            this.isEditAffidavitOpen = false;
        } 
    }

    public changeOrderList(mounted){
        if(!mounted) this.form4Info.orderList=[]
        if(this.form4Info.jurisdictionType == 'The Registrar')
            this.orderList = this.orderListRegistrar
        else if(this.form4Info.jurisdictionType == 'A Chambers Judge')
            this.orderList = this.orderListJudge
        else
            this.orderList = this.orderListCourt 
    }

    public updateSeekingOrder(){
        
        const formData = this.form4Info;
        const orderData = Array.isArray(formData.seekingOrder)? formData.seekingOrder: [];
        const orders: orderInfoType[] = []; 

        for (const orderName of this.form4Info.orderList){
           
            const matchingOrderRecords = orderData.filter(order => order.name == orderName);

            if (matchingOrderRecords.length == 0){
                orders.push({name: orderName, details: ''});
            } else {                
                const index = orderData.findIndex(order => order.name == matchingOrderRecords[0].name);               
                orders.push(orderData[index]);
            }            
        }

        formData.seekingOrder = orders;
        
        this.UpdateForm4Info(formData)
        this.recheckStates();
        this.updated ++;               

    }

    public allowedDates(date){
        const day = moment().startOf('day').format('YYYY-MM-DD');
        return (date >= day);           
    }

    public navigateToPreviewPage() {        
        this.$router.push({name: "preview-form4"}) 
    }

}
